import BasicLayout from '@/layouts/basic-layout';

const meta = {
    auth: true
};

const pre = 'bcos-contract';

export default {
    path: '/bcos/contract',
    name: '合约管理',
    redirect: {
        name: `${pre}ide`
    },
    meta,
    component: BasicLayout,
    children: [
        {
            path: 'ide',
            name: `${pre}ide`,
            meta: {
                ...meta,
                title: '合约IDE',
                closable: true
            },
            component: () => import('@/bcos/views/contract/ide.vue')
        },
        {
            path: 'list',
            name: `${pre}list`,
            meta: {
                ...meta,
                title: '合约列表',
                closable: true
            },
            component: () => import('@/bcos/views/contract/list.vue')
        },
        {
            path: 'warehouse',
            name: `${pre}warehouse`,
            meta: {
                ...meta,
                title: '合约仓库',
                closable: true
            },
            component: () => import('@/bcos/views/contract/warehouse.vue')
        },
        {
            path: 'cns',
            name: `${pre}cns`,
            meta: {
                ...meta,
                title: 'CNS 查询',
                closable: true
            },
            component: () => import('@/bcos/views/contract/cns.vue')
        },
        {
            path: 'crud',
            name: `${pre}crud`,
            meta: {
                ...meta,
                title: 'CRUD',
                closable: true
            },
            component: () => import('@/bcos/views/contract/crud.vue')
        },
        {
            path: 'eventCheck',
            name: `${pre}eventCheck`,
            meta: {
                ...meta,
                title: 'Event 查看',
                closable: true
            },
            component: () => import('@/bcos/views/contract/event-check.vue')
        },
    ]
};
